import React, {useState} from "react";
import {useCreditNotesData} from "../../hooks/useCreditNotesData";
import {useDispatch, useSelector} from "react-redux";
import {getCreditNotesData, getDataFresh, getDepartmentsData, getNominalCodesData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import {Box, Columns, Heading, Pagination, Table} from "react-bulma-components";
import TransactionCreditHeadings from "./TransactionCreditHeadings";
import TransactionCreditRow from "./TransactionCreditRow";
import axios from "axios";
import {createSetCreditNotesDataAction, createSetDataFreshAction} from "../../actions/dataActions";
import {NotificationManager} from "react-notifications";
import useSelect from "../../hooks/useSelect";
import InvoiceCreditHeading from "./InvoiceCreditHeading";
import InvoiceCreditRow from "./InvoiceCreditRow";
import {useNominalCodesData} from "../../hooks/useNominalCodesData";
import WorkCreditRow from "./WorkCreditRow";
import WorkCreditHeading from "./WorkCreditHeading";
import PartCreditRow from "./PartCreditRow";
import PartCreditHeading from "./PartCreditHeading";
import {formatXeroData, sendXeroData} from "../../utils";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import {act} from "react-dom/test-utils";


export default function CreditView(props){
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [selectedDepartment, setSelectedDepartment] = useState();
    const dataFresh = useSelector(getDataFresh);


    const [approvedView, approvedViewInput] = useSelect({
        label: "Approved State",
        options: [
          { name: "Not Approved", value: "not_approved" },
          { name: "Ready to Approve", value: "ready" },
          { name: "Approved", value: "approved" },
        ],
        initialValue: "not_approved",
        callback: () => {
          setPage(1);
        }
      });

    const [activeView, activeViewInput] = useSelect({
        label: "View",
        options: [
          { name: "Transaction", value: "transaction" },
          { name: "Movement Invoice", value: "movement" },
          { name: "Vehicle Sale Invoice", value: "sale"},
          { name: "Part Order Invoice", value: "part_order"},
          { name: "Work Items", value: "work"},
          { name: "Parts", value: "part"},
          { name: "Hire", value:"hire"}
        ],
        initialValue: "transaction",
        callback: () => {
          setPage(1);
        }
      });


    let params = {page: page};

    if(activeView){
        params.view = activeView
    }
    if(approvedView){
        params.approved = approvedView
    }
    if(selectedDepartment){
        params.department = selectedDepartment
    }


    const onChange = (e, index) => {
        let newCredit = {...data.results[index], [e.target.name]: e.target.value}
        data.results[index] = newCredit;
        dispatch(createSetCreditNotesDataAction(data.results));
    };

    const onNominalChange = (e, index) => {
        const toUpdate = {
            target:{
                name: e.target.name,
                value: codeObjects[e.target.value]
            }
        };
        onChange(toUpdate, index);
    }

    const sendData = (url, data, method) => {
        const conf = {
            url: props.endpoint+url,
            data: data,
            method: method
        }
        return axios(conf).catch(err => {
            NotificationManager.error("There was an error")
        });
    }

    const validator = data => {
        //nominal code
        // credit note number (sometimes)
        // amount/no_vat_amount (1 required)
        // date issued
        // Should the orign of the credit note have to be approved before the credit note can be?
        if((!data.vat_nominal_code && data.amount) || (!data.no_vat_nominal_code && data.no_vat_amount) || !data.date_issued){
            NotificationManager.warning("Date Issued and Nominal Code are required before approving");
            return false;
        }
        if(!(!!data.date_issued)){
            NotificationManager.warning("Date Issued is required");
            return false
        }
        if(!data.amount && !data.no_vat_amount){
            NotificationManager.warning("At least one of Amount or No VAT Amount are required");
            return false;
        }
        return true;
        // Credit number is required when we are credited or a purchase (expense)
    }

    const onReadyApprove = (data) => {
        sendData("creditready", data, "put").then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        })
    }
    const onApprove = (data) => {
        if(validator(data)) {
            sendData("creditapprove", data, "put").then(res => {
                //figure out if it is a sale or purchase credit note
                let source;
                let target;
                if ((data.transaction && data.transaction.type === "IN") || data.invoice || data.work || data.part) {
                    source = "CNS"
                    target = "SalesCreditNote"
                }
                else if((data.transaction && data.transaction.type === "OUT")){
                    source = "CNP"
                    target = "PurchaseCreditNote"
                }
                let credit = formatXeroData([res.data], source);
                console.log(credit);
                if(credit.XeroDept) {
                    // Only send data if the deptcode is correctly created (wont be created if the department is not 1 of the 3 that are sent to xero)
                    sendXeroData(credit, target).then(() => {
                        NotificationManager.success("Data has been sent to Xero");
                    }).catch(err => {
                        NotificationManager.error("There was an error sending data to xero")
                    })
                }
                console.log(credit);
                dispatch(createSetDataFreshAction(dataFresh + 1));
            })
        }
    }

    const onSave = data => {
       sendData(("credit/"+data.id), data, "put").then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        });
    }

    const onDelete = data => {
        sendData(("credit/"+data.id), data, "delete").then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        })
    }

    const onDepartmentChange = e => {
        setSelectedDepartment(e.target.value);
    }

    let loaded = useCreditNotesData(params, dataFresh);
    let nominalCodesLoaded = useNominalCodesData({page_size: 1000}, dataFresh);
    let departmentsLoaded = useDepartmentsData({}, dataFresh);
    const nominalCodes = useSelector(getNominalCodesData);
    const data = useSelector(getCreditNotesData);
    const departments = useSelector(getDepartmentsData);

    if(!loaded || !nominalCodesLoaded || !departmentsLoaded){
        return <LoadingSpinner />
    }

    const codeObjects = nominalCodes ? nominalCodes.results.reduce((obj, item) => {
        return {
            ...obj,
            [item["id"]]: item
        };
    }, {}) : [];


    return (
        <div>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Credit Notes</Heading>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        {approvedViewInput}
                    </Columns.Column>
                    <Columns.Column>
                        {activeViewInput}
                    </Columns.Column>
                    <Columns.Column>
                        <DepartmentPicker
                            selectedDepartment={selectedDepartment}
                            departments={departments}
                            onDepartmentChange={onDepartmentChange}
                        />
                    </Columns.Column>
                    <Columns.Column/>
                </Columns>
            </Box>
            <Box>
                <Columns>
                    <Columns.Column>
                        <Table
                            size={"fullwidth"}
                        >
                            <thead>
                                {activeView === "transaction" &&
                                    <TransactionCreditHeadings

                                    />
                                }
                                {(activeView === "movement" || activeView === "sale" || activeView === "part_order" || activeView === "hire") &&
                                    <InvoiceCreditHeading

                                    />
                                }
                                {activeView === "work" &&
                                    <WorkCreditHeading

                                    />
                                }
                                {activeView === "part" &&
                                    <PartCreditHeading

                                    />
                                }
                            </thead>
                            <tbody>
                            {activeView === "transaction" && data.results.map((credit, index) => (
                                <TransactionCreditRow
                                    data={credit}
                                    onDelete={onDelete}
                                    index={index}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onReadyApprove={onReadyApprove}
                                    onApprove={onApprove}
                                    nominalCodes={nominalCodes}
                                    onNominalChange={onNominalChange}
                                />
                            ))}
                            {(activeView === "movement" || activeView === "sale" || activeView === "part_order" || activeView === "hire") && data.results.map((credit, index) => (
                                <InvoiceCreditRow
                                    data={credit}
                                    onDelete={onDelete}
                                    index={index}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onReady={onReadyApprove}
                                    onApprove={onApprove}
                                    nominalCodes={nominalCodes}
                                    onNominalChange={onNominalChange}
                                />
                            ))}
                            {activeView === "work" && data.results.map((credit, index) => (
                                <WorkCreditRow
                                    data={credit}
                                    onDelete={onDelete}
                                    index={index}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onReady={onReadyApprove}
                                    onApprove={onApprove}
                                    nominalCodes={nominalCodes}
                                    onNominalChange={onNominalChange}
                                />
                            ))}
                            {activeView === "part" && data.results.map((credit, index) => (
                                <PartCreditRow
                                    data={credit}
                                    onDelete={onDelete}
                                    index={index}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onReady={onReadyApprove}
                                    onApprove={onApprove}
                                    nominalCodes={nominalCodes}
                                    onNominalChange={onNominalChange}
                                />
                            ))}
                            </tbody>
                        </Table>
                        <Pagination
                            showFirstLast={true}
                            onChange={setPage}
                            current={page}
                            total={Math.ceil(data.count / 25)}
                        >
                            {" "}
                        </Pagination>
                    </Columns.Column>
                </Columns>
            </Box>
        </div>
    )

}